<button class="make-payment__card">
  <div class="card__column">
    <img class="card__logo" src="/assets/imgs/mpass-logo.svg"  [alt]="'MPASS logo' | translate">
    @if(qrLocatorImage()){
      <img  class="card__qr" [src]="qrLocatorImage()"  [alt]="'MPASS qr' | translate">
    }
  </div>
</button>